import React from "react";
import FlightProgress from "../layout/FlightProgress";
import FlightDetailsHeader from "./FlightDetailsHeader";
import SelectedFlightOverview from "./SelectedFlightOverview";
import BaggageAndFareSummary from "./BaggageAndFareSummary";
import FareConditions from "./FareConditions";
import OperationalAlert from "./OperationalAlert";
import StickyBookingSummary from "./StickyBookingSummary";
import PriceChangeDialog from "./PriceChangeDialog";
import "./FlightDetailsScreen.css";

/**
 * Greenfield Details screen — presentation only.
 * Live mode: ViewModels via Wave1B bridge; showReprice=false; no raw props.
 */
export default function FlightDetailsScreen({
  offer,
  search,
  showReprice = false,
  onAcceptReprice,
  onDismissReprice,
  onContinue,
  onBack,
  reprice = null,
  continueLabel = "המשך לפרטי נוסעים",
  backLabel = "חזרה לתוצאות",
  continueDisabled = false,
  handlingFee = null,
  onHandlingFeeChange = null,
}) {
  if (!offer) {
    return (
      <div className="fe2-details-page fe2-details-page--empty">
        <p>לא נבחרה טיסה.</p>
        <button type="button" className="fe2-dhead__back" onClick={onBack}>
          ← {backLabel}
        </button>
      </div>
    );
  }

  return (
    <div className="fe2-details-page" data-fe2-details-screen="1">
      <FlightDetailsHeader search={search} onBack={onBack} />
      <FlightProgress activeStep="details" />

      <div className="fe2-details-page__grid">
        <div className="fe2-details-page__main">
          <SelectedFlightOverview offer={offer} />
          <BaggageAndFareSummary offer={offer} />
          <FareConditions conditions={offer.conditions} />
          <OperationalAlert alerts={offer.alerts} />
        </div>
        <div className="fe2-details-page__side">
          <StickyBookingSummary
            offer={offer}
            search={search}
            onContinue={onContinue}
            onBack={onBack}
            continueLabel={continueLabel}
            backLabel={backLabel}
            continueDisabled={continueDisabled}
            handlingFee={handlingFee}
            onHandlingFeeChange={onHandlingFeeChange}
          />
        </div>
      </div>

      {showReprice ? (
        <PriceChangeDialog
          reprice={reprice}
          onAccept={onAcceptReprice}
          onDismiss={onDismissReprice}
        />
      ) : null}
    </div>
  );
}
